import React, { useState } from 'react';
import './Contact.css';
import {
  FaPhone, FaEnvelope, FaInstagram, FaLinkedinIn, FaFacebook, FaYoutube, FaWhatsapp
} from 'react-icons/fa';
import { submitContactForm } from '../services/inquiryService';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    service: '',
    time: ''
  });
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.contact)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }
    try {
      await submitContactForm(formData);
      setShowPopup(true);
      setFormData({ name: '', contact: '', service: '', time: '' });
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  return (
    <div className="contact-page">
      {/* Page Heading */}
      <section className="page-header">
        <h1>Contact Us</h1>
      </section>

      {/* Section 1: Brand Info */}
      <section className="contact-info fade-in">
        <h2 className="slide-left">Reach Out to Us</h2>
        <p className="slide-right">Connect with us via Call, Email or other Social Platforms</p>
        <div className="contact-details">
          <a href='tel:9310771976'>
          <p className="slide-right"><FaPhone /> +91 9310771976</p></a>
          <a href='mailto:team@atelierbyshriji.in'><p className="slide-right"><FaEnvelope /> team@atelierbyshriji.in</p></a>
        </div>
        <div className="social-icons slide-right">
          <a href="https://www.instagram.com/atelierbyshriji?igsh=MWg2dzlqaXZ1ZTRtNw%3D%3D&utm_source=qr" target="_blank" rel="noreferrer"><FaInstagram /></a>
          <a href="https://www.facebook.com/share/16WZjPBSbE/?mibextid=wwXIfr" target="_blank" rel="noreferrer"><FaFacebook /></a>
          <a href="https://youtube.com/@shrijiagarwal?si=ABm8E-yorLkhHyPO" target="_blank" rel="noreferrer"><FaYoutube /></a>
          <a href="https://wa.me/919310771976" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
          <a href="https://www.linkedin.com/in/shriji-agarwal-ba414a232?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
        </div>
      </section>

      {/* Section 2: Contact Form */}
      <section className="contact-form fade-in">
        <h2 className="slide-left">Let's make some magic happen, reach out!</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="slide-right"
          />
          <input
            type="tel"
            name="contact"
            placeholder="Contact Number"
            value={formData.contact}
            onChange={handleChange}
            required
            className="slide-right"
          />
          <input
            type="text"
            name="service"
            placeholder="Message"
            value={formData.service}
            onChange={handleChange}
            required
            className="slide-right"
          />
          <label>Your Preferred Date & Time for Call ?</label>
          <input
            type="datetime-local"
            name="time"
            value={formData.time}
            onChange={handleChange}
            required
            className="slide-right"
          />
          <button type="submit" className="slide-right">Submit</button>
        </form>
      </section>

      {/* Popup Confirmation */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <p>Thank you for reaching out! Our team will be in touch soon.</p>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
